package dev.danko.roblox_craft_ai.state

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import dev.danko.roblox_craft_ai.client.RobloxCraftApiClient
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlinx.coroutines.withTimeoutOrNull

object BackendStatus {
    private const val RETRY_WHEN_DOWN_MS = 5_000L
    private const val RECHECK_WHEN_UP_MS = 30_000L

    var reachable: Boolean? by mutableStateOf(null)
        private set

    private val recheckRequests = Channel<Unit>(Channel.CONFLATED)

    fun requestRecheck() {
        recheckRequests.trySend(Unit)
    }

    @Composable
    fun Monitor() {
        LaunchedEffect(Unit) {
            while (isActive) {
                reachable = RobloxCraftApiClient.isBackendReachable()
                val pause = if (reachable == true) RECHECK_WHEN_UP_MS else RETRY_WHEN_DOWN_MS
                withTimeoutOrNull(pause) { recheckRequests.receive() }
            }
        }
    }
}
